import { useState, type ComponentType } from 'react';

import type { MediaPickerComponent } from '../../../../editor/commands/button-image';
import { EditorPlain } from '../../../../editor/components/editor-plain';
import { LabelWithoutRef } from '../../../../label/label-without-ref';

type ImageUrlProps = {
  id: string;
  label?: string;
  value: string;
  mediaPicker?: ComponentType<MediaPickerComponent>;
  onChange: (value: string) => void;
};

export function ImageUrl({
  id,
  label = 'URL de imagen',
  value,
  mediaPicker: MediaPicker,
  onChange,
}: ImageUrlProps) {
  const [isMediaPickerOpen, setIsMediaPickerOpen] = useState(false);

  return (
    <div>
      <LabelWithoutRef className="text-xs font-medium text-muted-foreground">
        {label}
      </LabelWithoutRef>
      <EditorPlain
        button={
          MediaPicker
            ? {
                text: 'Seleccionar imagen de CDN',
                onClick: () => setIsMediaPickerOpen(true),
              }
            : undefined
        }
        id={id}
        type="input"
        value={value}
        onChange={(nextValue) => {
          if (nextValue !== value) onChange(nextValue);
        }}
      />
      {MediaPicker ? (
        <MediaPicker
          open={isMediaPickerOpen}
          onOpenChange={setIsMediaPickerOpen}
          onSubmit={({ url }) => {
            onChange(url);
            setIsMediaPickerOpen(false);
          }}
        />
      ) : null}
    </div>
  );
}
